import {Grid, GridSize, Hidden, makeStyles} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import { Theme } from '@material-ui/core/styles';
import ButtonClose from 'components/ButtonClose/ButtonClose';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { GenericButton } from '../../../../../components/GenericButton/GenericButton';
import { colors } from '../../../../../theme/theme';
import { addLineBreaks } from '../../../../../utils/formatString';
import {AppState, SalesType} from "../../../../../types/redux";
import {useSelector} from "react-redux";

interface SelectSignatureModalProps {
	showModal: boolean;
	sendEmailErrorMessage?: string | null;
	onSelectSendEmail?(): void;
	onSelectSignDigital?(): void;
	onSelectSignPrint?(): void;
	onCancel(): void;
}

const useStyles = makeStyles((theme: Theme) => ({
	paper: {
		marginRight: '30px',
		position: 'absolute',
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		outline: 'none',
		justifyItems: 'center',
		padding: 24,
		color: '#4B4B4D',
		fontSize: '16px',
		fontWeight: 600,
		letterSpacing: '0.25px',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '70%',
		maxWidth: 680,
	},

	separator: {
		width: 1,
		position: 'absolute',
		top: 24,
		right: 0,
		bottom: 24,
		backgroundColor: theme.palette.primary.main,
	},
	selectItem: {
		position: 'relative',
		fontWeight: 400,
		display: 'flex',
		flexDirection: 'column',
		padding: '25px 10px 25px 10px'
	},
	selectItemHeading: {
		//
	},
	selectItemDescription: {
		flex: '1 0 auto',
	},
	selectItemButtonWrapper: {
		display: 'flex',
		marginTop: 20,
		marginBottom: 20,
		alignItems: 'center',
		flexDirection: 'column',
	},
	button: {
		// margin: '10px',
	},
	textBetweenButtons: {
		margin: 10,
	},
	errorMessage: {
		color: colors.red,
		fontSize: 14,
		marginTop: 2,
	},
}));

export const SelectSignatureModal: React.FC<SelectSignatureModalProps> = (
	props
) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const salesTypes = useSelector<AppState, SalesType[]>( state => state.user.salesType );
	let isNotEp = !salesTypes.includes(SalesType.EPK) && !salesTypes.includes(SalesType.EPH);
	const sizeSm:GridSize = isNotEp ? 6 : 12;
	const sizeXs:GridSize = isNotEp ? 12 : 12;

	return (
		<Modal open={props.showModal} onClose={props.onCancel}>
			<div className={classes.paper}>
				<Grid container spacing={0}>
					{ isNotEp &&
					<Grid item xs={12} sm={6} className={classes.selectItem}>
						<h2 className={classes.selectItemHeading}>
							{t('selectSignatureModal.signLater.heading')}
						</h2>
						<div className={classes.selectItemDescription}>
							{addLineBreaks(t('selectSignatureModal.signLater.description'))}
						</div>
						<div className={classes.selectItemButtonWrapper}>
							<GenericButton
								data-cy="btn-sign-later"
								className={classes.button}
								onClick={props.onSelectSendEmail}
								variant="outlined"
								color="primary"
								fullWidth={true}
							>
								{t('selectSignatureModal.signLater.btnEmailLabel')}
							</GenericButton>
						</div>
						{props.sendEmailErrorMessage && (
							<div className={classes.errorMessage}>
								{props.sendEmailErrorMessage}
							</div>
						)}
						<Hidden xsDown>
							<div className={classes.separator} />
						</Hidden>
					</Grid> }
					<Grid item xs={sizeXs} sm={sizeSm} className={classes.selectItem}>
						<h2 className={classes.selectItemHeading}>
							{t('selectSignatureModal.signNow.heading')}
						</h2>
						<div className={classes.selectItemDescription}>
							{addLineBreaks(t('selectSignatureModal.signNow.description'))}
						</div>
						<div className={classes.selectItemButtonWrapper}>
							<GenericButton
								data-cy="btn-sign-now"
								className={classes.button}
								onClick={props.onSelectSignDigital}
								variant="contained"
								color="primary"
								fullWidth={true}
							>
								{t('selectSignatureModal.signNow.btnDigitalLabel')}
							</GenericButton>
						</div>
					</Grid>
				</Grid>
				<ButtonClose onClick={props.onCancel} />
			</div>
		</Modal>
	);
};
